import React from "react";
import discover from "../../assets/img/svg/discover.svg";
import design from "../../assets/img/svg/design.svg";
import build from "../../assets/img/svg/build.svg";
import deliver from "../../assets/img/svg/deliver.svg";

function Process() {
  return (
    <>
      <section className="wrapper bg-light ">
        <div className="container ">
          <div className="row text-center">
            <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <h2 className="fs-16 text-uppercase text-muted mb-3">
                How We Work
              </h2>
              <h3 className="display-4 mb-10 px-xl-10">
                From first call to launch in four clear steps
              </h3>
            </div>
            {/* /column */}
          </div>
          {/* /.row */}
          <div className="position-relative">
            <div
              className="shape rounded-circle bg-soft-blue rellax w-16 h-16"
              data-rellax-speed={1}
              style={{ bottom: "-0.5rem", right: "-2.2rem", zIndex: 0 }}
            />
            <div
              className="shape bg-dot primary rellax w-16 h-17"
              data-rellax-speed={1}
              style={{ top: "-0.5rem", left: "-2.5rem", zIndex: 0 }}
            />
            <div
              className="row gx-md-5 gy-5 text-center process"
              // data-aos="zoom-in"
            >
              <div className="col-md-6 col-xl-3">
                <div className="card shadow-lg">
                  <div className="card-body">
                    <img
                      src={discover}
                      className="icon-svg icon-svg-md text-yellow mb-3"
                      alt=""
                    />
                    <h4>Discover</h4>
                    <p className="mb-2">
                      We dig into your goals, users and data to define the
                      right problem, scope and success metrics.
                    </p>
                    {/* <a href="#" className="more hover link-yellow">
                      Learn More
                    </a> */}
                  </div>
                  {/*/.card-body */}
                </div>
                {/*/.card */}
              </div>
              {/*/column */}
              <div className="col-md-6 col-xl-3">
                <div className="card shadow-lg">
                  <div className="card-body">
                    <img
                      src={design}
                      className="icon-svg icon-svg-md text-red mb-3"
                      alt=""
                    />
                    <h4>Design</h4>
                    <p className="mb-2">
                      Wireframes and interactive prototypes that make complex
                      workflows feel simple — validated before we build.
                    </p>
                    {/* <a href="#" className="more hover link-red">
                      Learn More
                    </a> */}
                  </div>
                  {/*/.card-body */}
                </div>
                {/*/.card */}
              </div>
              {/*/column */}
              <div className="col-md-6 col-xl-3">
                <div className="card shadow-lg">
                  <div className="card-body">
                    <img
                      src={build}
                      className="icon-svg icon-svg-md text-green mb-3"
                      alt=""
                    />
                    <h4>Build</h4>
                    <p className="mb-2">
                      Agile sprints with weekly demos, clean architecture,
                      automated tests and security built in from day one.
                    </p>
                    {/* <a href="#" className="more hover link-green">
                      Learn More
                    </a> */}
                  </div>
                  {/*/.card-body */}
                </div>
                {/*/.card */}
              </div>
              {/*/column */}
              <div className="col-md-6 col-xl-3">
                <div className="card shadow-lg">
                  <div className="card-body">
                    <img
                      src={deliver}
                      className="icon-svg icon-svg-md text-blue mb-3"
                      alt=""
                    />
                    <h4>Deliver</h4>
                    <p className="mb-2">
                      Smooth production rollout with monitoring, then ongoing
                      support and iteration as your product grows.
                    </p>
                    {/* <a href="#" className="more hover link-blue">
                      Learn More
                    </a> */}
                  </div>
                  {/*/.card-body */}
                </div>
                {/*/.card */}
              </div>
              {/*/column */}
            </div>
            {/*/.row */}
          </div>
          {/* /.position-relative */}
        </div>
        {/* /.container */}
      </section>
    </>
  );
}

export default Process;
